import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from 'components/atoms/Text';
import mapModifiers from 'utils/functions';

interface LoadingProps {
  variant?:'fullScreen' | 'default';
  isShow?:boolean;
  isShowText?: boolean;
  isFill?: boolean;
  theme?: 'dark' | 'light';
  size?: 'small' | 'default';
}

const Loading: React.FC<LoadingProps> = ({
  isShow = false,
  variant,
  isShowText,
  isFill,
  theme,
  size,
}) => {
  const { t } = useTranslation();
  if (!isShow) return null;
  return (
    <div className={mapModifiers('a-loading', variant, isFill && 'filled', size)}>
      <div className="a-loading_wrapper">
        <div className={mapModifiers('a-loading_tail', size)} />
        {isShowText && (
          <Text
            type="span"
            modifiers={[theme === 'light' ? 'raisinBlack' : 'white']}
            content={t('overview.loading')}
          />
        )}
      </div>
    </div>
  );
};

Loading.defaultProps = {
  variant: 'default',
  isShow: false,
  isShowText: false,
  isFill: false,
  theme: 'light',
  size: 'default',
};

export default Loading;
